import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import Icon from "./Icon";

export default function LoginPage() {
  const { instance } = useMsal();

  function handleLogin() {
    instance.loginPopup(loginRequest).catch(console.error);
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <svg viewBox="0 0 24 24"><path d="M13 2.05v2.02c3.95.49 7 3.85 7 7.93 0 3.21-1.81 6-4.72 7.28L13 17v5l5-3-1.22-1.22C19.91 16.07 22 13.14 22 10c0-5.18-3.95-9.45-9-9.95zM11 2.05C5.95 2.55 2 6.82 2 12c0 3.14 2.09 6.07 5.22 7.78L6 21l5 3v-5l-2.28 2.28C6.81 20 5 17.21 5 14c0-4.08 3.05-7.44 7-7.93V2.05z" fill="#fff"/></svg>
        </div>
        <h1>Portal Power Tuning</h1>
        <p>Central de ferramentas para consultores.<br />Entre com sua conta corporativa Microsoft.</p>
        <button className="btn-login" onClick={handleLogin}>
          <svg viewBox="0 0 23 23" style={{width:18,height:18}}>
            <rect x="1" y="1" width="10" height="10" fill="#f25022"/>
            <rect x="12" y="1" width="10" height="10" fill="#7fba00"/>
            <rect x="1" y="12" width="10" height="10" fill="#00a4ef"/>
            <rect x="12" y="12" width="10" height="10" fill="#ffb900"/>
          </svg>
          Entrar com Microsoft
        </button>
      </div>
    </div>
  );
}
